import { CreateAndIssueUser, CreateUser } from "../types/graphql";
import { IssueByQrCode } from "@ist-group-private-scope/skolid-client-components";

export function issuedWithActivationCode(
  type: CreateAndIssueUser | IssueByQrCode | CreateUser
): type is CreateAndIssueUser {
  return !!(type as CreateAndIssueUser).createAndIssueUser;
}
